// assets
import {
  DashboardOutlined,
  PushpinOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
} from "@ant-design/icons"

// icons
const icons = {
  DashboardOutlined,
  PushpinOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
}

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: "dashboard",
  // title: 'Navigation',
  type: "group",
  children: [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: "/dashboard",
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
    },
    // {
    //   id: 'location',
    //   title: 'Locations',
    //   type: 'item',
    //   url: '/location',
    //   icon: icons.PushpinOutlined,
    //   breadcrumbs: false
    // },

    {
      id: "appointments",
      title: "Appointments",
      type: "item",
      url: "/appointments",
      icon: icons.CarryOutOutlined,
      breadcrumbs: false,
    },
  ],
}

export default dashboard
